import { ApiContext, apiContextFetch } from "@/hooks/api/base"

interface InitiateRingoutParams {
  integrationId: string
  integrationType: string
  toPhone: string
  inboxPhone?: string
}

export function initiateRingout(
  context: ApiContext,
  { integrationId, integrationType, toPhone, inboxPhone }: InitiateRingoutParams
) {
  return apiContextFetch<void>(context, "ringouts", {
    method: "POST",
    body: JSON.stringify({
      integration_id: integrationId,
      integration_type: integrationType,
      to_phone: toPhone,
      inbox_phone: inboxPhone,
    }),
  })
}
